import * as ACTION_TYPES from './Types';

const initialState = {
  stockDetails: {},
  message: '',
  error: null,
}

export const stockReducer = (state = initialState, action) => {
  switch (action.type) {

    case ACTION_TYPES.GETSTOCK_SUCCESS:
      return {
        ...state,
        stockDetails: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.GETSTOCK_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }

    default:
      return state;
  }
}
